export class LockCurrentlyLockedError extends Error {
  constructor(message, lock) {
    super(message);
    this.lock = lock;
  }
}
export class Lock {
  constructor(onLockChange) {
    this.isLocked = false;
    this.onLockChange = onLockChange;
  }
  acquire() {
    if (this.isLocked) {
      throw new LockCurrentlyLockedError("Could not acquire lock: Lock is already locked. ", this);
    }
    this.isLocked = true;
    this.onLockChange(this.isLocked);
  }
  release() {
    this.isLocked = false;
    this.onLockChange(this.isLocked);
  }
}
